/* eslint-disable react/jsx-no-target-blank */
import text from '../lib/dictionary.json';
import { useAuth } from "../AuthProvider";
import { APP_EMAIL, APP_NAME, APP_PHONE, APP_VERSION, APP_WEBSITE, APP_WHATSAPP } from "../Constants";
import Modal from './Modal';
import '../components/form-fields/form-item.css';

const ProjectInfo = ({ close }) => {
    const { lang } = useAuth();

    return (
        <Modal
            isView
            disableDefaultButton
            close={close}
            alignment={lang === 'en'}
            customStyles={{ width: '512px', height: '480px' }}
            headerText={text[lang]['info-header']}
            cancelText={text[lang]['cancel']}>
            <div className="form-item" style={{ margin: '12px 0' }}>
                <label className="form-label">
                    {text[lang]['info-name']}
                </label>
                <p>{APP_NAME}</p>
            </div>
            <div className="form-item" style={{ margin: '12px 0' }}>
                <label className="form-label">
                    {text[lang]['info-version']}
                </label>
                <p>{APP_VERSION}</p>
            </div>
            <div className="form-item" style={{ margin: '12px 0' }}>
                <label className="form-label">
                    {text[lang]['info-phone']}
                </label>
                <p>{APP_PHONE}</p>
            </div>
            <div className="form-item" style={{ margin: '12px 0' }}>
                <label className="form-label">
                    {text[lang]['info-whatsapp']}
                </label>
                <a title={text[lang]['info-whatsapp']} href="https://wa.me/+971581149388" target="_blank">
                    {APP_WHATSAPP}
                </a>
            </div>
            <div className="form-item" style={{ margin: '12px 0' }}>
                <label className="form-label">
                    {text[lang]['info-email']}
                </label>
                <a title={text[lang]['info-email']} href="mailto:info@sama-tech.ae">
                    {APP_EMAIL}
                </a>
            </div>
            <div className="form-item" style={{ margin: '12px 0' }}>
                <label className="form-label">
                    {text[lang]['info-website']}
                </label>
                <a title="Website" href="http://www.sama-tech.ae" target="_blank">
                    {APP_WEBSITE}
                </a>
            </div>
        </Modal>
    );
};

export default ProjectInfo;